import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=2d6fb0eb&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6fb0eb')) {
      api.createRecord('2d6fb0eb', component.options)
    } else {
      api.reload('2d6fb0eb', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=2d6fb0eb&", function () {
      api.rerender('2d6fb0eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layouts/AppMain.vue"
export default component.exports